$(document).ready(function() {

  // Email signup in footer, pink promo bars, and various other landing pages,
  // e.g. /calendars
  function regEmail(emailSignupModule) {
    var input = emailSignupModule.find('input[type="email"]');
    var userType = emailSignupModule.data('user-type');
    var extraContext = emailSignupModule.data('extra-context');
    var reentryPoint = emailSignupModule.data('reentry-point');
    var dataString = JSON.stringify({
      "email": input.val(),
      "type": userType,
      "reentryPoint": reentryPoint,
      "extraContext": extraContext
    });
    $.post('/email-signup', {
        data: dataString
      },
      function(response) {
        input.val(response);
        // track in GA
        gaTrackEventWrapper(
          "registration",
          "mailing list registration",
          window.location.pathname,
          userType
        );
      }, "text");
  }

  var emailSignupModule = $('.emailSignupModule');
  if (emailSignupModule.length > 0) {
    emailSignupModule.each(function() {
      var that = $(this);
      var buttonSignup = that.find('.btnSignup');
      var input = that.find('input[type="text"]');
      buttonSignup.bind('click', function() {
        regEmail(that);
      });
      input.bind('focus', function() {
        $(this).val('');
      });
      input.bind('keydown', function(event) {
        if (event.keyCode == 13) {
          event.returnValue = false;
          return false;
        }
      });
      input.bind('keypress', function(event) {
        if (event.keyCode == 13) {
          regEmail(that);
          return false;
        }
      });
    });
  }

});